import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import LocationSearchMap from "./LocationSearchMap.js";
const LocationSearchMapContainer = (props) => {
  const { getLabel } = useIntl();
  const { featureConfigs } = useFeatureToggles();
  const labels = React.useMemo(
    () => ({
      shareCurrentLocation: getLabel("locations.search.map.shareCurrentLocation")
    }),
    [getLabel]
  );
  const mapOptions = {
    minZoom: 3,
    maxZoom: 19,
    mapId: featureConfigs?.googleDynamicMapsMapId,
    styles: [
      {
        featureType: "poi.business",
        stylers: [{ visibility: "off" }]
      },
      {
        featureType: "poi.attraction",
        stylers: [{ visibility: "off" }]
      }
    ],
    scrollwheel: !MediaQuery.useIsBelow(MediaQuery.BreakpointName.DESKTOP),
    zoomControl: !MediaQuery.useIsBelow(MediaQuery.BreakpointName.DESKTOP)
  };
  return /* @__PURE__ */ React.createElement(LocationSearchMap, { ...props, labels, mapOptions });
};
export {
  LocationSearchMapContainer as default
};
//# sourceMappingURL=LocationSearchMapContainer.js.map
